import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AppLayout } from 'src/features/layouts';
import AppRoutes from '../data/app-routes';
import LoginSuccessful from 'src/pages/login-success-page';
import LoginPage from 'src/pages/login-page';
import NotFoundPage from 'src/pages/not-found-page';
import UnauthorizedPage from 'src/pages/unauthorized-page';
import RequireAuth from 'src/features/auth/components/require-auth';
import { UserRole } from 'src/features/auth/data/auth-data';
import ClientsPage from 'src/pages/clients-page';
import FormClientPage from 'src/pages/form-client-page';
import ClientComponent from 'src/features/clients/components/form/client-component';
import AddClientComponent from 'src/features/clients/components/form/add-client-component';

const AppRouter: React.FC = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route element={<AppLayout />}>
                    <Route
                        key="indexPath"
                        path={AppRoutes.rootPath}
                        index={true}
                        element={
                            <RequireAuth role={UserRole['SD.LockerPlugin.Admin']} redirect={true}>
                                <ClientsPage />
                            </RequireAuth>
                        }
                    />
                    <Route key="loginPath" path={AppRoutes.loginPath} element={<LoginPage />} />
                    <Route
                        key="unauthorizedPath"
                        path={AppRoutes.unauthorizedPath}
                        element={<UnauthorizedPage />}
                    />
                    <Route
                        key="loginSuccessfullPath"
                        path={AppRoutes.loginSuccessfullPath}
                        element={<LoginSuccessful key="loginSuccessfullPage" />}
                    />
                    <Route
                        key="clientDetailsPath"
                        path={AppRoutes.viewClientPath}
                        element={
                            <RequireAuth role={UserRole['SD.LockerPlugin.Admin']} redirect={true}>
                                <FormClientPage key="formClientPageDetailClient">
                                    <ClientComponent key="clientDetailsComponent" />
                                </FormClientPage>
                            </RequireAuth>
                        }
                    />
                    <Route
                        key="addClientPath"
                        path={AppRoutes.addClientPath}
                        element={
                            <RequireAuth role={UserRole['SD.LockerPlugin.Admin']} redirect={true}>
                                <FormClientPage key="formClientPageAddClient">
                                    <AddClientComponent key="addClientComponent" />
                                </FormClientPage>
                            </RequireAuth>
                        }
                    />
                    <Route key="notFoundPage" path="*" element={<NotFoundPage />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
};

export default AppRouter;
